import {Vue, Component, Ref, Model, Prop} from "vue-property-decorator";
import SegmentSources from "@/components/SegmentSources.vue";
import type {SegmentSource} from "@/components/SegmentSources";

type Segment = {
    id: string,
    name: string,
    size: number,
    unions: Array<EventSource>,
    intersections: Array<EventSource>,
    differences: Array<EventSource>,
    created_at: string,
}

type EventSource = {
    event_id: string,
    key: string,
    value_type: string,
    value: string,
    type: string,
}

type SegmentsModel = {
    headers: any
    data: Array<Segment>
    loading: boolean
}

import {
    Pixel as SSPixel,
    Event as SSEvent,
    Category as SSCategory,
    Segment as SSSegment,
} from '@/components/SegmentSources'

@Component({
    components: {
        SegmentSources
    }
})
export default class CreateSegment extends Vue {
    @Model('input') private dialog: Boolean = false

    private closeDialog() {
        this.$emit('input', false)
    }

    @Prop() private events_source!: Array<SSEvent>
    @Prop() private pixels_source!: Array<SSPixel>
    @Prop() private segments_source!: Array<SSSegment>
    @Prop() private categories_source!: Array<SSCategory>
    @Prop() private title!: string
    @Prop({
        default: 'Create'
    }) private action_title!: string

    private name: string | null = null

    private name_rules = [
        (v: string) => !!v || 'Name is required',
    ]

    @Ref('union') unionSource !: SegmentSources
    @Ref('diff') diffSource !: SegmentSources
    @Ref('inter') interSource !: SegmentSources
    @Ref('create_name') createName !: any

    private sources: any = {
        error: "",
        union: [] as Array<SegmentSource>,
        intersection: [] as Array<SegmentSource>,
        difference: [] as Array<SegmentSource>,
    }

    private segments: SegmentsModel = {
        headers: [
            {
                text: "ID",
                value: "id"
            },
            {
                text: "Name",
                value: "name"
            },
            {
                text: "Size",
                value: "size"
            },
            {
                text: "Created",
                value: "created_at"
            },
            {
                text: "",
                value: "actions"
            }
        ],
        data: [] as Array<Segment>,
        loading: true,
    }

    create() {
        if (!this.validateCreate()) {
            return
        }

        let ss = {
            name: this.name,
            unions: this.sources.union,
            intersections: this.sources.intersection,
            differences: this.sources.difference,
        } as Segment

        this.reset()

        this.emitCreate(ss)
    }

    validateCreate(): boolean {
        let valid = this.validateUnionIntersection()
        valid = this.unionSource.validate() && valid
        valid = this.interSource.validate() && valid
        valid = this.diffSource.validate() && valid
        valid = this.createName.validate(true) && valid
        return valid
    }

    validateUnionIntersection(): boolean {
        if (this.sources.union.length + this.sources.intersection.length == 0) {
            this.sources.error = "At least one item in union or intersection is required"
            return false
        }
        this.sources.error = ''
        return true
    }

    reset() {
        this.sources.error = ''
        this.sources.intersection = []
        this.sources.difference = []
        this.sources.union = []
        this.name = ''
        this.createName.reset()
    }

    emitCreate(obj: any) {
        this.$emit('create', obj)
    }

    public setSources(
        unions: Array<SegmentSource>,
        intersections: Array<SegmentSource>,
        differences: Array<SegmentSource>,
    ) {
        if(this.unionSource) {
            this.unionSource.loadMissingComponents(unions)
            this.interSource.loadMissingComponents(intersections)
            this.diffSource.loadMissingComponents(differences)
        }

        this.sources.union = unions || []
        this.sources.intersection = intersections || []
        this.sources.difference = differences || []
        this.sources.error = ''
    }

    public setName(name: string) {
        this.name = name
    }
}